import * as React from "react";
import c from "classnames";
import * as SC from "./style"


import { useState } from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const Menu = (props: any) => {
  const [isOpen, setisOpen] = useState(false);
  const renderTooltip = (filter: string) => {
    return (<Tooltip id="tooltip-top" placement="top" className="in TooltipSidebar">
      {filter}
    </Tooltip>)
  }

  return (
    <>
      <SC.StyledMenu>
        <OverlayTrigger
          placement="right"
          delay={100}
          overlay={renderTooltip(props.titleName)}
        >
          <div className="menu hover_elem" >
            <div className={`${props.isCompany ? " " : " "}${c("nav-item ", { active: isOpen }, { "nav-item-active": props.ActiveColor })}`} >
              <div className="nav-link">
                {props.icon ?
                  <span className="img" onClick={() => { props.changeTab(); }}>
                    {props.titleLogo}
                  </span>
                  :
                  (
                    <span className="img" onClick={() => { props.changeTab(); }}>
                      <img className="nav-icon" src={props.titleLogo} />
                    </span>
                  )}
                <div className="df">
                  <span className="text" onClick={() => { setisOpen(false); props.changeTab(); }}>{props.title}</span>
                </div>
                {props.titleIcon && (
                  <span className="nav-icon" onClick={() => { setisOpen(false); props.changeTab(); }}>{props.titleIcon}</span>
                )}
              </div>
            </div>
            <div className={c("dropdown hover_item", { active: isOpen }, { isCompany: props.isCompany })}  >
              <ul className="dropdown-list">
                {props?.dropdownList?.length && props.dropdownList.map((item: any, index: number) => {
                  return (
                    item !== false && <Link onClick={() => { props.changeTab(); setisOpen(false); }} key={index} to={item.link} className="links" style={{ width: '100%' }}>
                      {item.itemLogo ? <img className="itemlogo" src={item.itemLogo} /> : ""}
                      <div>
                        {item.name ? <div>{item.name}</div> : ""}
                        {item.description ? <div className="desText">{item.description}</div> : ""}
                      </div>
                    </Link>
                  )
                })}
              </ul>
            </div>
          </div>
        </OverlayTrigger>
      </SC.StyledMenu>
    </>
  );
};

export default Menu;



// WEBPACK FOOTER //
// ./src/pages/common/Menu/index.tsx